
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Component} from "vue-property-decorator";
import {SiteNewsUpdateRequestType} from "./newsUpdate.types.";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {maxLength, minLength, numeric, required} from "vuelidate/lib/validators";
import {INewsListItem} from "@/entity/Settings/news.types";

@Component
export default class SiteNewsUpdateForm extends Form {

    @Validate(required, i18nText("Введите назавание категории"))
    id: number | null = null;
    name: string | null = null;
    preview_text: string | null = null;
    image: Record<string, string> | null = {};
    image_file: File | null = null;

    getFormData(): SiteNewsUpdateRequestType {
        return {
            id: this.id,
            name: this.name,
            preview_text: this.preview_text,
            image: this.image,
            image_file: this.image_file,
        }
    }

    setFormData(news: INewsListItem): void {
        console.clear();
        console.log('this set form ');
        console.log(news);
        this.id = news.id;
        this.name = news.name;
        this.preview_text = news.preview_text;
        this.image = news.image;
    }
}
